import { Empty } from 'antd'
import React from 'react'

const Dashboard = ({ userData }) => {
    return (
        <Empty />
    )
}

export default Dashboard